import { parseDate } from '@/enterprise/features/history/utils';
import { dateAsIsoString } from '@/utils/dateAsIsoString';
import DatePicker from '../../DatePicker';

const DateRangePicker = ({
  to,
  from,
  onFromChange,
  onToChange,
  toOpen,
  fromOpen,
  onToOpenChange,
  onFromOpenChange,
  name,
}: {
  to?: string | null;
  from?: string | null;
  onFromChange: (date: string | null) => void;
  onToChange: (date: string | null) => void;
  toOpen: boolean;
  fromOpen: boolean;
  onToOpenChange: (open: boolean) => void;
  onFromOpenChange: (open: boolean) => void;
  name: string;
}) => {
  return (
    <div className="flex gap-2 pt-2">
      <DatePicker
        {...(to && {
          disabledOptions: { after: parseDate(to) },
        })}
        open={fromOpen}
        onOpenChange={() => onFromOpenChange(!fromOpen)}
        onSelect={(date) => {
          onFromOpenChange(false);
          onFromChange(dateAsIsoString(date) ?? null);
        }}
        selected={from ?? null}
        trigger={
          <div
            aria-label={`${name} From`}
            className="flex w-32 items-center rounded border border-stroke bg-white p-3"
            role="button"
          >
            {from ?? 'From'}
          </div>
        }
        defaultMonth={from ? parseDate(from) : to ? parseDate(to) : new Date()}
      />
      <DatePicker
        {...(from && {
          disabledOptions: { before: parseDate(from) },
        })}
        open={toOpen}
        onOpenChange={() => onToOpenChange(!toOpen)}
        onSelect={(date) => {
          onToOpenChange(false);
          onToChange(dateAsIsoString(date) ?? null);
        }}
        selected={to ?? null}
        trigger={
          <div
            aria-label={`${name} To`}
            className="flex w-32 items-center rounded border border-stroke bg-white p-3"
            role="button"
          >
            {to ?? 'To'}
          </div>
        }
        defaultMonth={to ? parseDate(to) : from ? parseDate(from) : new Date()}
      />
    </div>
  );
};

export default DateRangePicker;
